const MIN_BIRTH_YEAR = 1900;

/** Returns { min, max } as YYYY-MM-DD strings for a birthdate input.
 *  max = today, min = 1 Jan of MIN_BIRTH_YEAR. */
export function birthDateBounds(): { min: string; max: string } {
    const today = new Date();
    const max = today.toISOString().split("T")[0];
    const min = `${MIN_BIRTH_YEAR}-01-01`;
    return { min, max };
}

/** Returns true if the date string (YYYY-MM-DD) is within the allowed range. */
export function isBirthDateValid(value: string): boolean {
    if (!value) return false;
    const year = parseInt(value.slice(0, 4), 10);
    if (isNaN(year) || year < MIN_BIRTH_YEAR) return false;
    const { min, max } = birthDateBounds();
    return value >= min && value <= max;
}
